import { Typography, Grid } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useTabContext } from "../../context/tabs/TabContext";
import { getWithdrawnAmountChartInfo } from "../../api/clubs/club.api";
import { convertChartData } from "../../common/helpers/chart.helper";
import { convertStatisticData } from "../../common/helpers/statistics.helper";
import { IChartInfo, IChart } from "../../common/interfaces/chart.interface";
import { IWithdrawalOverview } from "../../common/interfaces/club.interface";
import { IStatistics } from "../../common/interfaces/statistic.interface";
import SideInfo from "../../pages/Platform/SideInfo";
import AppCard from "../cards/AppCard";
import { PeriodFilter } from "../../common/enums/common.enums";
import BarChart from "../charts/BarChart";

const ClubWithdrawal: FC<{
  withdrawalOverview: IWithdrawalOverview;
  clubAddress: string;
}> = ({ clubAddress, withdrawalOverview }) => {
  const [withdrawalChartInfo, setWithdrawalChartInfo] = useState<IChart[]>();
  const [withdrawalChartInfoStatistics, setWithdrawalChartInfoStatistics] =
    useState<IStatistics>();
  const [chartTab, setChartTab] = useState<string>(PeriodFilter.DAILY);

  useEffect(() => {
    void getWithdrawalChartInfo();
  }, []);

  const getWithdrawalChartInfo = async () => {
    try {
      const response: IChartInfo = await getWithdrawnAmountChartInfo(
        clubAddress
      );
      console.log(clubAddress);
      console.log(response);
      const convertedChartData: IChart[] | undefined = convertChartData(
        response,
        "Total withdrawn amount"
      );
      setWithdrawalChartInfo(convertedChartData);
      const statisticData = convertStatisticData(response);
      setWithdrawalChartInfoStatistics(statisticData);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <Typography variant="subtitle1" my={1}>
        Withdrawals
      </Typography>
      <Grid
        container
        spacing={{ xs: 1, md: 4, sm: 5 }}
        columns={{ xs: 3, sm: 8, md: 10 }}
        my={1}
      >
        <Grid item xs={12} sm={12} md={5}>
          <useTabContext.Provider
            value={{
              tab: chartTab,
              changeTab: (tabPeriod: PeriodFilter) => setChartTab(tabPeriod),
            }}
          >
            <SideInfo statisticsData={withdrawalChartInfoStatistics} />
            <BarChart chartData={withdrawalChartInfo} />
          </useTabContext.Provider>
        </Grid>
        <Grid
          item
          container
          xs={12}
          sm={12}
          md={5}
          direction={"column"}
          justifyContent={"center"}
          gap={2}
        >
          <AppCard
            label={"Total withdrawal amount"}
            value={
              withdrawalOverview?.totalWithdrawalAmount
                ? withdrawalOverview.totalWithdrawalAmount
                : 0
            }
          />
          <AppCard
            label={"Number of withdrawals"}
            value={
              withdrawalOverview?.withdrawalCount
                ? withdrawalOverview.withdrawalCount
                : 0
            }
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default ClubWithdrawal;
